<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          <span>Edit Franchisee Staff</span>
        </v-card-title>
        <page-loader :loading="isFetching" />
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.first_name"
                outlined
                label="First Name *"
                prepend-inner-icon="mdi-account"
                :error-messages="errors.first_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.middle_name"
                outlined
                label="Middle Name"
                prepend-inner-icon="mdi-account"
                :error-messages="errors.middle_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.last_name"
                outlined
                label="Last Name *"
                prepend-inner-icon="mdi-account"
                :error-messages="errors.last_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.email"
                outlined
                label="Email *"
                prepend-inner-icon="mdi-email"
                :error-messages="errors.email"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone *"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                outlined
                v-model="form.position_id"
                :items="positionItems"
                label="Position *"
                prepend-inner-icon="mdi-account-tie-outline"
                readonly
                :error-messages="errors.position_id"
                hint="Position: Franchisee Staff"
                persistent-hint
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                :loading="isFranchiseeLoading"
                outlined
                v-model="form.franchisee_id"
                :items="franchiseeItems"
                label="Franchisee Admin *"
                prepend-inner-icon="mdi-account-star"
                clearable
                :error-messages="errors.franchisee_id"
                hint="Select franchisee admin for this staff"
                persistent-hint
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <bank-details-fields :form="form" />
          <v-divider class="mt-5 mb-5"></v-divider>
          <v-btn v-can:edit="['franchisee_staffs', 'my_staff']"
            :loading="isLoading"
            :disabled="isLoading"
            color="primary"
            rounded
            @click="save"
          >
            <v-icon left>mdi-content-save</v-icon>
            Update Franchisee Staff
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "FranchiseeStaffEditPage",
  data() {
    return {
      form: {},
      isLoading: false,
      isFetching: false,
      positionItems: [],
      franchiseeItems: [],
      isFranchiseeLoading: false,
    };
  },
  async mounted() {
    this.isFetching = true;
    try {
      await this.getMasters();
      await this.getFranchisees();
      await this.getData();
    } finally {
      this.isFetching = false;
    }
  },
  methods: {
    async getMasters() {
      try {
        const response = await axios.get(
          `masters?context=user&franchise_kyc=1&franchisee_status=1`
        );
        const masters = response.data;

        // Load positions
        masters.positions.forEach((position) => {
          this.positionItems.push({
            id: position.id,
            text: position.name,
            value: position.id,
          });
        });
      } catch (error) {
        console.error("Error loading masters:", error);
        this.isUnAuthorised();
      }
    },

    async getFranchisees() {
      this.isFranchiseeLoading = true;
      try {
        const response = await axios.get("franchisees?is_active=1&status=1");
        this.franchiseeItems = [];
        if (response.data.data) {
          response.data.data.forEach((franchisee) => {
            this.franchiseeItems.push({
              id: franchisee.id,
              text: `${franchisee.name} (${franchisee.email})`,
              value: franchisee.id,
            });
          });
        }
      } catch (error) {
        console.error("Error fetching franchisees:", error);
        this.isUnAuthorised();
      }
      this.isFranchiseeLoading = false;
    },

    async getData() {
      try {
        const encryptedId = this.$route.params.id;
        const response = await axios.get(`/users/${encryptedId}`);
        this.form = response.data.data;
      } catch (error) {
        console.error("Error fetching user data:", error);
        this.isUnAuthorised();
      }
    },

    async save() {
      try {
        this.isLoading = true;

        // Validate franchisee_id
        if (!this.form.franchisee_id) {
          this.isShowPopUP("Error", "Please select a franchisee admin", "error");
          this.isLoading = false;
          return;
        }

        const encryptedId = this.$route.params.id;

        await axios.patch(`/users/${encryptedId}`, this.form);

        await this.saveUserTimestamp(null, this.form);

        this.isShowPopUP(
          "Success",
          "Franchisee staff updated successfully",
          "success"
        );

        this.isLoading = false;
        this.$router.back();
      } catch (error) {
        console.error("Error updating franchisee staff:", error);
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
